import {create} from "zustand";
import {WorkdayWithEmployee} from "@src/httpClient/__generated__/Api.ts";
import {WorkDay} from "@src/db.ts";

interface WorkDaysStore {
    workdays?: WorkdayWithEmployee[] | WorkDay[]
    currentWorkDay?: WorkdayWithEmployee | WorkDay
    setCurrentWorkDay: (workday?:  WorkdayWithEmployee | WorkDay) => void
    setWorkdays: (workday?: WorkdayWithEmployee[] | WorkDay[]) => void
}


export const useWorkDaysStore = create<WorkDaysStore>((set) => ({
    workdays: undefined,
    currentWorkDay: undefined,
    setCurrentWorkDay: (currentWorkDay?: WorkdayWithEmployee | WorkDay) => {
        set({currentWorkDay})
    },
    setWorkdays: (workdays?: WorkdayWithEmployee[] | WorkDay[]) => {
        set({workdays})
    },
}))